/**
 * Product Component
 */

//jshint ignore:start
(function(itxApp) {

    'use strict';

    /**
     * Product Component
     * @type ItxProductCmpCtrl
     * @name productCtrl
     */
    var ItxProductCmp = {
        bindings: {
            hasDialog: '<',
            product: '<',
            onProductColorChanged: '&'
        },
        controller: ItxProductCmpCtrl,
        controllerAs: 'productCtrl',
        templateUrl: 'ItxProductCmp.html'
    };

    angular.module('itxApp.catalog')
        .component('itxProduct', ItxProductCmp);

    ItxProductCmpCtrl.$inject = [
        '$scope',
        '$element',
        '$rootScope',
        '$timeout',
        '$window',
        'ngDialog',
        'ItxShopCartFct',
        'ItxProductSwiperSvc',
        'ItxConstants',
        'ItxScreenSizeSvc',
        'ItxUtilsFct',
        'imProductService',
        'ItxWishlistSvc',
        'ItxSizeGuideSvc',
        'ItxTranslateSvc',
        'ProductRelatedSvc',
        'CmsConfigSvc',
        'ProductCustomizeService',
        'CommonServices',
        'DUTTI_CONS',
        'ItxStyleAdvisorSvc',
        'ItxStaticResourceSvc'
    ];

    function ItxProductCmpCtrl(
        $scope, 
        $element, 
        $rootScope, 
        $timeout, 
        $window, 
        ngDialog, 
        ItxShopCartFct, 
        ItxProductSwiperSvc,
        ItxConstants, 
        ItxScreenSizeSvc, 
        ItxUtilsFct, 
        imProductService,  
        ItxWishlistSvc, 
        ItxSizeGuideSvc,
        ItxTranslateSvc,
        ProductRelatedSvc,
        CmsConfigSvc,
        ProductCustomizeService,
        CommonServices,
        DUTTI_CONS,
        ItxStyleAdvisorSvc,
        ItxStaticResourceSvc
    ) {
        var _this = this;
        
        _this.ItxConstants = ItxConstants;
        _this.ItxScreenSizeSvc = ItxScreenSizeSvc;
        _this.ItxUtilsFct = ItxUtilsFct;
        _this.isProductBean = false;
        _this.hasDoubleImage = false;
        _this.doubleImage = null;
        _this.madeIn = null;
        _this.sizeguideMessage = null;
        _this.fitanalyticsMessage = null;
        //Bundle methods & variables
        _this.showRelated = false;
        _this.showSlider = true;
        _this.showAddToCartPopup = false;
        // _this.addedFromPopup = false;
        _this.$element = $element;
        // _this.showSelectedColorName = false;
        _this.ItxProductSwiperSvc = ItxProductSwiperSvc;
        _this.isRelatedPopupOpened = false;
        _this.pushAddToCart = false;
        _this.pushAddToWhislist = false;
        _this.showSizeMessage = false;
        _this.showSpecialMspotFamilies = false;
        _this.openCustomizeDialogClicked = false;

        // Mostrar para personalizados de unica referencia
        _this.productUniqueReference = false; // esta info nos llega por color con la nueva version de api
        _this.showCustomizationButton = false;

        // Se muestra boton comprar si la cesta tiene productos
        _this.productAdded = false;
        _this.redirectToWorldWide = inditex.iStoreJSON.redirectToWorldWide;

        inditex.getXconfiguracionValue('SHOW_SPECIAL_MSPOT_FAMILIES', function(status, value) {
            _this.showSpecialMspotFamilies = value && value !== '0';
        });

        _this.openSizeGuideMeasurements = function() {
            ItxSizeGuideSvc.openPopup(_this.product, 'garmentMeasurements');
        };

        inditex.onReady(function(){
            _this.isOpenForSale = joyr.catalog.utils.isOpenForSale();
        });

        //Initialize page controller
        _this.$onInit = function(){
            
            _this.size_icon = ItxStaticResourceSvc.getImage('size_dark-gray.png');

            _this.isWishlistActive = ItxWishlistSvc.isActive;
            
            
            if(!_this.hasDialog && ItxShopCartFct && ItxShopCartFct.shopCart.state && !ItxShopCartFct.shopCart.state.isEmpty){
                _this.productAdded = true;
            }     

                
        }

        _this.openModalRedirect = function (isAvailable) {
            var dialog = ngDialog.open({
                data: {
                    product: _this.product,
                    isAvailable: isAvailable
                },
                template: '<itx-product-redirect></itx-product-redirect>',
                plain: true,
                className: 'contact-dialog ngdialog-theme-plain new-modal',
                showClose: true,
                preCloseCallback: function () {
                    _this.pushAddToCart = false;
                }
            });

        }

        

        _this.addToCartButtonXs = function(){
            if (_this.product.state.selectedSize && 
                _this.product.state.selectedSize.visibility != 'coming_soon' &&
                _this.product.state.selectedSize.visibility != 'back_soon') 
            {
                var posTitleProduct = $('.ma-product-detail-wrap').offset();
                $('html, body').animate({ scrollTop: posTitleProduct.top-70 }, 250);
                _this.addToCart();
            } else {
                _this.pushAddToCart = true;
                ItxUtilsFct.overlayIn(_this.hasDialog);
            }
        }

        /**
         * IMAnalytics triggerPageview y escuchador cierre Popups
         */
        if(!$scope.$$listenerCount['imHidePopup']){
            $scope.$on('imHidePopup', function() {
                if (inditex.iPage === 'ItxProductPage') {
                    imTriggerPageview();
                }
            });
        }

        initializeEvents();

        // ng-if="shopCartButtonCtrl."
        _this.init = function() {
            
            let lastRelated = undefined;
            const cookieGroup = DUTTI_CONS.COOKIE_GROUPS.FUNCTIONAL_PERSONALIZATION;
            const isCookieGroupAllowed = CommonServices.isCookieGroupAllowed(cookieGroup);

            if(isCookieGroupAllowed){
                lastRelated = inditex.getLocalStorage('LAST_RELATED');
                if(lastRelated === _this.product.id){
                    _this.product.setRelated(true);
                    // Remove from storage
                    inditex.removeLocalStorage('LAST_RELATED');
                }
            }

            ProductRelatedSvc.setProductRecentlyViewed(_this.product);

            _this.showGarmentMasurements = checkShowGarmentMeasurements();
            
            //IMAnalytics
            if(!imProductService.isProductDialog()) {
                $window.imAnalytics.productJSON = _this.product;
                imTriggerPageview();               
            }

            // validacion productos de unica referencia para personalizados
            // debe estar la variable de configuracion activada y tener el optional a true
            // if(_this.confUniqueReference && _this.product.state &&
            if(_this.product.state &&
                _this.product.state.selectedColor &&
                _this.product.state.selectedColor.customizations &&
                _this.product.state.selectedColor.customizations.customizationDetails && 
                _this.product.state.selectedColor.customizations.customizationDetails.optional){
                    _this.productUniqueReference = true;                    
            }


            if(_this.product.state.xcustomization){
                CmsConfigSvc.getProperty('customizable_product_whitelist')
                .then(function (value) {
                    _this.confMocacosUR = _.keyBy(value); 
                    var mocaco = _this.product.getMocacocode();
                    if(mocaco){
                        var moca = mocaco.slice(0, -3);
                        var findMocaco = _.find(_this.confMocacosUR, function (id) {
                                return moca === id;
                            });
                        
                        if(findMocaco){
                            _this.showCustomizationButton = true;
                        }
                    }
                });
            }
        };

        _this.$onChanges = function(){
            if(!_this.product){return;}
            _this.init();  
        }

        
        _this.onRequireSizeWhislist = function(){
            _this.pushAddToWhislist = true;
            ItxUtilsFct.overlayIn(_this.hasDialog);
        }

        _this.sizeSelected = function(sizeSelected){
            if (inditex.iPage != 'ItxCategoryPage') {
                _this.sizeRecomendation(sizeSelected);
            }

            _this.product.state.selectedSize = sizeSelected;
            ItxUtilsFct.overlayOff(_this.hasDialog);
            if( _this.pushAddToCart ){ 
                if( _this.product.state.selectedSize.visibility != 'coming_soon' && _this.product.state.selectedSize.visibility != 'back_soon'){                
                    _this.addToCart();
                }
            } 
            else if( _this.pushAddToWhislist ){
                _this.pushAddToWhislist = false;
                _this.whislistSelectedSize = true;
            }
            // Abre la ventana modal de customizaziones
            else if(_this.openCustomizeDialogClicked){
                _this.openCustomizeDialog();
            }
        }
        
        _this.onSizeMessage=function(){
            _this.showSizeMessage = true;
            $timeout(function() {
                _this.showSizeMessage = false;
            }, 3000);
        }

        _this.getDoubleImage = function(colorIndex) {
            var type = ItxUtilsFct.getImageType('doubleBox');
            var size = ItxUtilsFct.getImageSize('grid');
            var image = null;
            if (!_this.product.isBundleBean) {
                image = _this.product.activeDetail.colors[ _this.product.state.selectedColorIndex].image;
            } else {
                image = _this.product.image;
            }
            var images = inditex.getProductImageUrls(image, type, size);

            return images[0];
        };

        //zoom for double images
        _this.doubleImageZoom = function($event) {
            
            if (_this.doubleImage) {
                $rootScope.$broadcast('itx-product-zoom:initialize', {
                    images: [_this.doubleImage],
                    index: 0,
                    event: $event
                });
            }
        };

        _this.clickChangeColor = function(color){
            _this.fitanalyticsMessage = false;
            _this.sizeguideMessage = false;
            _this.onShowBulletPercentage(false);
            _this.product.setColor(color);
            _this.onProductColorChanged({color:color});
            $scope.$emit('itx-change-color:'+_this.product.id, color);
        }

        _this.goToShoppingCart = function() {
            $window.location.href = joyr.utils.getCommonPageUrl('ItxShopCartPage', false, false);
            /*
             * IMAnalytics - event 'Tramitar pedido' on product file
             */
            imProductService.goToShoppingCart();
        };


        _this.addToCart = function(uniqueReference) {
            if(uniqueReference){
                delete _this.product.customization
            }
            if (_this.itemOutOfStock()) {
                if (_this.redirectToWorldWide) {
                    redirectToWorldWideFn();
                    return;
                }
                return;
            }

            if (_this.redirectToWorldWide) {
                _this.openModalRedirect(true);
                return;
            }

            // En caso de haber seleccionado la talla y de que ésta no sea de tipo "Coming soon" o  "Back soon"
            if ( ItxShopCartFct.canIAddItems() &&
                _this.product.state.selectedSize &&
                _this.product.state.selectedSize.visibility != 'coming_soon' &&
                _this.product.state.selectedSize.visibility != 'back_soon')
            {
                // Añadimos el producto en el carrito
                _this.productAdded = true;

                ItxShopCartFct.addToCart(
                    _this.product,
                    _this.product.activeDetail.colors[_this.product.state.selectedColorIndex],
                    _this.product.state.selectedSize,
                    null)
                .then(function() {

                    _this.pushAddToCart = false;

                    if(ngDialog){
                        ngDialog.close();
                    }

                    if(!_this.hasDialog){
                        ProductRelatedSvc.openPopupRelateds(angular.copy(_this.product));
                    }
                });
            }  else {
                // Mostramos el selector de tallas
                _this.pushAddToCart = true;
                ItxUtilsFct.overlayIn(_this.hasDialog);         
            }
        };

        function redirectToWorldWideFn() {
            _this.openModalRedirect(false);
        }

        _this.showOverlay = function(){
            ItxUtilsFct.overlayIn(_this.hasDialog);
        }
        _this.hideOverlay = function(){
            ItxUtilsFct.overlayOff(_this.hasDialog);
        }
        /**
         * ngdoc method
         * @methodOf common.product.product-view-menu.component:itxProductViewMenu
         * @name goToShopCart
         * @description
         * Navigate to shop cart.
         */
        _this.goToShopCart = function() {
            $window.location.href = joyr.utils.getCommonPageUrl('ItxShopCartPage', false, false);
        };

        _this.getInfoDialogData = function() {
            return {
                product: _this.product,
                selectedColor: _this.product.state.selectedColorIndex
            };
        };

        _this.openSizeGuide = function () {
            ItxSizeGuideSvc.openPopup(_this.product, 'equivalence');
            imProductService.eventSizeGuide(_this.product);
        };

        _this.openSizeGuideAlert = function () {
            $timeout(function () {
                $('.size-guide').click();
            });
        };

        _this.itemOutOfStock = function() {
            let isOoutOfStock = false;
            if (_this.product &&
                _this.product.activeDetail.colors &&
                _this.product.activeDetail.colors.length &&
                _this.product.state.selectedColorIndex >= 0
            ) {
                if (
                    _this.product &&
                    _this.product.state &&
                    _this.product.state.selectedSize &&
                    _this.product.state.selectedSize.visibility == 'disabled'
                ) {
                    isOoutOfStock = true;
                } else {
                    isOoutOfStock = _this.product.activeDetail.colors[_this.product.state.selectedColorIndex].sizes.length === 0 ||
                        _this.uniqueSize && (_this.uniqueSize.visibility === 'disabled' || _this.uniqueSize.visibility === 'coming_soon' || _this.uniqueSize.visibility === 'back_soon');
                }
            } else {
                isOoutOfStock = false;
            }

            return isOoutOfStock;
        };

        function imTriggerPageview() {
            /**
             * IMAnalytics Vista de catalogo, Ficha de producto
             */
            if (_this.product && (inditex.iProductId === _this.product.id)) {
                if (_this.product.isBundleBean && _this.product.bundleProductSummaries.length) {
                    imProductService.createViewBundle(_this.product, _this.product.state.selectedColorIndex);
                } else { 
                    imProductService.createView(_this.product, _this.product.state.selectedColorIndex);
                }

                // Manda las analíticas también a Hero (solo en caso de disponer de Style Advisor activo)
                ItxStyleAdvisorSvc.checkIfEnabled().then(function (isActive) {
                    if (isActive) {
                        var productImages = ItxUtilsFct.getProductXmediaImagesData(_this.product, ItxConstants.xmediaLocations['productPage']);

                        imProductService.sendProductViewToHero(_this.product, _this.product.state.selectedColorIndex, productImages);
                    }
                });
            }
        }

        _this.changeRelatedVisibility = function() {
            _this.showRelated = !_this.showRelated;
            if (_this.showRelated) {
                $timeout(function() {
                    _this.showSlider = !_this.showSlider;
                }, 300);
            } else {
                _this.showSlider = !_this.showSlider;
            }
        };

        _this.getSelectedColorName = function() {
            if (_this.product && _this.product.activeDetail && _this.product.activeDetail.colors && _this.product.activeDetail.colors[_this.product.state.selectedColorIndex] && _this.product.state.selectedColorIndex >= 0) {
                return _.capitalize(_this.product.activeDetail.colors[_this.product.state.selectedColorIndex].name);
            }
        };

        _this.openCustomizeDialog = function() {
            
            // Primero comprueba que se haya seleccionado la talla y que el producto no esté en "Coming Soon" o "Back soon"
            if (ItxShopCartFct.canIAddItems() && 
                _this.product.state.selectedSize && 
                _this.product.state.selectedSize.visibility != 'coming_soon' &&
                _this.product.state.selectedSize.visibility != 'back_soon'){

                ProductCustomizeService.openCustomizeProduct(_this.product);

            }
            // En caso de no haber seleccionado talla o de que no haya, muestra el selector de tallas
            else {
                _this.openCustomizeDialogClicked = true;
                ItxUtilsFct.overlayIn(_this.hasDialog);
            }  
        }

        _this.onShowBulletPercentage = (percentage) => {
            _this.bulletPercentage = percentage;
        }

        function checkShowGarmentMeasurements() {
            var res = false;
            var confActive = ItxSizeGuideSvc.isGarmentMeasurementsActive();
            var hasSkuDimensions = _this.product && ItxSizeGuideSvc.hasSkuDimensions(_this.product);
            if(confActive && hasSkuDimensions){
                res = true;
            }
            return res;
        };

        function initializeEvents(){
            $rootScope.$on('wideyes:addProductToCart', function($event, data) {

                ItxShopCartFct.addToCart(
                        data.product,
                        data.color,
                        data.size,
                        null)
                    .then(function() {
                        // _this.addedFromPopup = true;
                        $scope.$apply();
                    });
            });
        }

        _this.sizeRecomendation = function (size) {
            _this.fitanalyticsMessage = false;
            _this.sizeguideMessage = false;
            var fitanalytics = document.getElementsByClassName('fitanalytics__button');
            var cartState = ItxShopCartFct.getState().state;
            if (cartState.totalItems != 0) {
                cartState.renderItems.forEach(function (cartProduct) {
                    // El modelo es el mismo
                    if (_this.product.id === cartProduct.parentId) {
                        // El color es el mismo
                        if (_this.product.state.selectedColor.id === cartProduct.colorId) {
                            // La talla es diferente
                            if (size.name != cartProduct.size) {
                                if (fitanalytics.length > 0) {
                                    if (cartProduct.quantity > 0) {
                                        _this.fitanalyticsMessage = true;
                                    }
                                } else {
                                    if (cartProduct.quantity > 0) {
                                        _this.sizeguideMessage = true;
                                    }
                                }
                            }
                            // La talla es la misma
                            if (size.name === cartProduct.size) {
                                _this.fitanalyticsMessage = false;
                                _this.sizeguideMessage = false;
                            }
                        }
                    }
                });
            }
        };
    }
})();

//jshint ignore:end